// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { AxiosPromise } from 'axios';

import { CreditMethod, PaginationListResponse, SearchCondition } from '../types/Model';
import { authGet, authPost, post, parseCamelCase, parseSnakeCase, get, authUploadPost } from './util';
import { ProductCard } from '../components/NewCard/types';

const baseURL = '/exam'

export const searchExams = (limit: number, page: number, params: SearchCondition): AxiosPromise<PaginationListResponse<ProductCard>> => {
  return authPost(`${baseURL}/exams/search`, parseSnakeCase({
    limit,
    page,
    condition: 'exams',
    name: params.name || undefined,
    platformIds: params.platformId ? [params.platformId] : undefined,
    domainIds: params.domainIds.length > 0 ? params.domainIds : undefined,
    levelIds: params.levelId ? [params.levelId] : undefined,
  }), {
    transformResponse: (data: any) => parseCamelCase(data.result)
  });
};

export const searchExamsKeyword = (limit: number, name?: string): AxiosPromise => {
  return authPost(`${baseURL}/exams/keyword`, parseSnakeCase({
    limit: limit,
    name: name || undefined
  }), {
    transformResponse: (data: any) => parseCamelCase(data.result)
  });
};

export const getExamInformation = (id: number, condition = 'Buy', workshopId?: number, iltCourseId?: number): AxiosPromise => {
  const query = workshopId ? `?workshopId=${workshopId}` : iltCourseId ? `?iltCourseId=${iltCourseId}` : `?condition=${condition}`;

  return authGet(`${baseURL}/exams/${id}/information${query}`, {
    withCredentials: true,
    transformResponse: (data: unknown) => {
      const parsed = parseCamelCase(data);

      if ('relatedWorkshop' in parsed) {
        const { startTime, endTime, ...workshop } = parsed.relatedWorkshop;
        return {
          ...parsed,
          relatedWorkshop: {
            ...workshop,
            startTime: new Date(startTime),
            endTime: new Date(endTime),
          }
        }
      }
      return parsed;
    }
  });
};

export const buyExam = (id: number, test?: boolean, creditMethod?: CreditMethod, workshopId?: number, courseId?: number, iltCourseId?: number): AxiosPromise => {
  const query = workshopId ? `?workshopId=${workshopId}` : '';
  const courseQuery = courseId ? `?courseId=${courseId}` : '';
  const iltCourseQuery = iltCourseId ? `?iltCourseId=${iltCourseId}` : '';
  return authPost(`${baseURL}/exams/${id}/buy${query}${courseQuery}${iltCourseQuery}`, parseSnakeCase({
    test,
    creditMethod: creditMethod === CreditMethod.OrganizationCredit ? CreditMethod.OrganizationCredit: undefined
  }), {
    transformResponse: (data: any) => {
      const parsed = parseCamelCase(data);
      return parsed;
    }
  });
};

export const endExam = (id: number, examRecordId: number, choosedAnswer: any, choosedQnaAnswer: any): AxiosPromise => {
  return authPost(`${baseURL}/exams/${id}/endExam`, parseSnakeCase({
    examRecordId,
    choosedAnswer,
    choosedQnaAnswer
  }), {
    transformResponse: (data: any) => {
      const parsed = parseCamelCase(data);

      return parsed;
    }
  });
};

export const retakeQuestion = (id: number): AxiosPromise => {
  return authGet(`${baseURL}/exams/${id}/retakeQuestion`, {
    transformResponse: (data: any) => {
      const parsed = parseCamelCase(data);

      return parsed;
    }
  });
};

export const getUploadUrl = (examId: number, examRecordId: number, fileList: any): AxiosPromise => {
  return authUploadPost(`${baseURL}/exams/uploadFile`, {
    examId,
    examRecordId,
    fileList
  }, {
    transformResponse: (data: any) => {
      const parsed = parseCamelCase(data);

      return parsed;
    }
  });
};

export const getExamReviewData = (id: number, token: string): AxiosPromise => {
  const query = `?id=${id}&token=${token}`;
  return get(`${baseURL}/exams/getReview${query}`, {
    withCredentials: true,
    transformResponse: (data: any) => {
      const parsed = parseCamelCase(data);

      return parsed;
    }
  });
};

export const submitReview = (id: number, reviewList: any, token: string, examId: string): AxiosPromise => {
  const query = `?id=${id}`;
  return post(`${baseURL}/exams/submitReview${query}`, parseSnakeCase({
    reviewList,
    token,
    examId
  }), {
    transformResponse: (data: any) => {
      const parsed = parseCamelCase(data);

      return parsed;
    }
  });
};
